import { render } from "./UserPwd.vue?vue&type=template&id=399eee08&scoped=true"
import script from "./UserPwd.vue?vue&type=script&lang=js"
export * from "./UserPwd.vue?vue&type=script&lang=js"

import "./UserPwd.vue?vue&type=style&index=0&id=399eee08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399eee08"]])

export default __exports__